export default "__VITE_ASSET__CxVZFayJ__"